<template>
    <!-- IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): быстрые настройки шестерёнки графа — разметка панели AttrGraph
         (.widget-commandPanel-2 над островком справа внизу; панель команд скрыта — справа вверху): флажок — pi-check-square / pi-stop (toggle), список — pi-circle-fill / pi-circle (set).
         Наведение на панель держит её открытой (hover true / false — как onShow / onClose_graphQuickSettings AttrGraph). uiHelp — helpPrefix + ключ опции -->
    <div class="widget-commandPanel-2 gqp-panel" v-show="show" :class="corner === 'tr' ? 'gqp-tr' : 'gqp-br'" @mouseenter="$emit('hover', true)" @mouseleave="$emit('hover', false)">
        <template v-for="opt in options" :key="opt.key">
            <div v-if="opt.items" class="mb-1" style="white-space:nowrap;" v-uiHelp="helpKey(opt)">
                <div class="mb-1" style="opacity:.7">{{ opt.title }}</div>
                <div v-for="it in opt.items" :key="it.id" class="ml-3" style="cursor:pointer;" @click.stop="$emit('set', opt, it.id)">
                    <i :class="['pi', opt.value === it.id ? 'pi-circle-fill' : 'pi-circle', 'mr-2']"/>
                    <span>{{ it.title }}</span>
                </div>
            </div>
            <div v-else class="mb-1" style="cursor:pointer; white-space:nowrap;" @click.stop="$emit('toggle', opt)" v-uiHelp="{ key: helpKey(opt), state: () => (opt.value ? 'on' : 'off') }">
                <i :class="['pi', opt.value ? 'pi-check-square' : 'pi-stop', 'mr-2']"/>
                <span>{{ opt.title }}</span>
            </div>
        </template>
    </div>
</template>

<script>
// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): см. шаблон; потребитель — AttrSchemeGraphV2 (список — utils/graphPanel.js)
import { useMainStore } from '@/stores/mainStore'

export default {
    name: 'GraphQuickPanel',
    setup() { return { store: useMainStore() } },   // store для глобального mixin callgraph (beforeCreate читает this.store.findWidget(widget_id)), как GraphPanelIsland
    props: {
        widget_id: [String, Number],
        show: { type: Boolean, default: false },
        corner: { type: String, default: 'br' },
        options: { type: Array, default: () => [] },
        helpPrefix: { type: String, default: 'chart.graph.qs.' },
    },
    emits: ['hover', 'toggle', 'set'],
    methods: {
        helpKey(opt) { return this.helpPrefix + (opt && opt.key) },
    },
}
</script>

<style>
/* IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): место и размер — как у быстрой панели AttrGraph (стили строкой там же) */
.gqp-panel { position: absolute; right: 8px; z-index: 7; padding: 8px 12px; min-width: 250px; }
.gqp-panel.gqp-br { bottom: 46px; }
.gqp-panel.gqp-tr { top: 2px; }
</style>
